

import React, { useState } from 'react'

import {Table, Thead, Tbody, Tr, Th, Td} from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

import categories from '../categorybutton/categories.js'

import './styles.scss';

var linkifyHtml = require('linkifyjs/html');

function DetailTable(props) {

  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const maxEntries = 10;

  var filteredData = props.data;
  // Filter by Search
  if(search !== "")
  {
    filteredData = filteredData.filter(e => {
      return e[1][1].toLowerCase().includes(search.toLowerCase()) 
      || e[1][2].toLowerCase().includes(search.toLowerCase())
      || e[1][3].toLowerCase().includes(search.toLowerCase())
      || e[1][4].toLowerCase().includes(search.toLowerCase())
      || e[1][5].toLowerCase().includes(search.toLowerCase())
    })
  }

  // Filter by Page
  var data = filteredData.filter((e, i) => i >= page * maxEntries && i < (page + 1) * maxEntries)
  if(page * maxEntries > filteredData.length)
    setPage(0)

  const format = s => {
    var s = s.replace(/\n/g, '<br />' );
    return <span dangerouslySetInnerHTML={{__html: linkifyHtml(s, {defaultProtocol: 'https'})}} />
  }  

  return (
    <div className='detailtable'>
    <h4>Eingetragene Geschäfte gemäss ausgewählter Kategorie</h4>
    
    <div className="search ui left icon input search">
      <input type="text" placeholder="Search..." onChange={e => setSearch(e.target.value)} />
      <i className="search icon"></i>
    </div>

    <Table cellSpacing={0} cellPadding={0}>
      <Thead>
        <Tr>
        <Th>Kategorie</Th>
        <Th>Name</Th>
        <Th>Beschreibung</Th>
        <Th>Kontakt</Th>
        <Th>Ort</Th>
       
        </Tr>
      </Thead> 
      <Tbody>
       {data.map((f, i) => {
         return <Tr key={i}>
           <Td>{categories.find(c => c.ident === f[1][0])['text']}</Td>
           <Td>{format(f[1][1])}</Td>
           <Td>{format(f[1][2])}</Td>
           <Td>{format(f[1][3])}</Td>
           <Td><>{f[1][4]} <br />{f[1][5]}</></Td>
          </Tr>
      })}

      </Tbody>
    </Table>

    <div className="pagination">
      <button onClick={() => setPage(page - 1)} disabled={!(page > 0)}>
        <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"></path></svg>
      </button>{' '}
          
      Seite <b>{page + 1}</b> von <b>{(Math.ceil(filteredData.length / maxEntries))}</b>
      <button onClick={() => setPage(page + 1)} disabled={!(page < Math.ceil(filteredData.length / maxEntries) - 1)}>
        <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"></path></svg>
      </button>
    </div>
      </div>    
  )
}


export default DetailTable
